export const formatCurrency = (
  amount: number,
  currency = "GBP",
  locale = typeof window !== "undefined" ? navigator.language : "en-GB",
) =>
  new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
  }).format(amount / 100);
